import { GlobalStatus, StockStatus, TransactionType } from "@gtpl/shared-models/common-models";
import { StoreConsumptionStatus } from "@gtpl/shared-models/procurement-management";
import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { StoreReturn } from "../../store-returns/store-return.entity";
import { StoreConsumptionItems } from "./store-consumption-items.entity";

@Entity('store_consumption')
export class StoreConsumption {
    @PrimaryGeneratedColumn('increment', {
        name: 'store_consumption_id',
    })
    storeConsumptionId: number;

    @Column('datetime', {
        nullable: false,
        name: 'indent_date',
    })
    indentDate: Date;
    
    @Column('varchar', {
        nullable: true,
        name: 'indent_no',
    })
    indentNo: string;

    @Column('varchar', {
        nullable: false,
        name: 'store_consumption_code',
        default:0
    })
    storeConsumptionCode: string;

    @Column('datetime', {
        nullable: false,
        name: 'consumed_date',
    })
    consumedDate: Date;

    @Column('int', {
        nullable: false,
        name: 'sale_order_id',
    })
    saleOrderId: number;

    @Column('int', {
        nullable: true,
        name: 'sale_order_item_id',
    })
    saleOrderItemId: number;

    @Column('int', {
        nullable: false,
        name: 'unit_id',
        default:0
    })
    unitId: number;

    @Column('int', {
        nullable: true,
        name: 'sale_person',
    })
    salePerson: number;

    @Column({
        type: 'enum',
        enum: StoreConsumptionStatus,
        nullable: false,
        name: 'status',
        default:StoreConsumptionStatus.Open
    })
    status: StoreConsumptionStatus;
    @Column({
        type: 'enum',
        enum: GlobalStatus,
        nullable: false,
        name: 'is_repared_material',
    })
    isPreparedMaterial: GlobalStatus;
    @Column('int', {
        nullable: false,
        name: 'item_id',
    })
    itemId: number;
    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        name: "issued_quantity",
        default: 0,
        unsigned:true
    })
    issuedQuantity: number;
    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        name: "returned_quantity",
        default: 0,
        unsigned:true
    })
    returnedQuantity: number;
    @Column({
        type: "decimal", precision: 10, scale: 3,
        nullable: false,
        name: "stock_in_quantity",
        default: 0,
        unsigned:true
    })
    stockInQuantity: number;
    @Column("varchar", {
        nullable: true,
        name: "barcode",
        length:155,
      })
      barcode: string;
      @Column("varchar", {
        nullable: true,
        name: "product_name",
        length:155,
      })
      productName: string;
      @Column({
        type: 'enum',
        enum: StockStatus,
        nullable: true,
        name: 'stock_type',
        default:"SaleOrder",
    })
    stockType: StockStatus;
    @Column({
        type: 'enum',
        enum: TransactionType,
        nullable: true,
        name: 'transaction_type',
        default:TransactionType.rm,
    })
    transactionType: TransactionType;

    @CreateDateColumn({
        name: 'created_at'
    })
    createdAt: Date;

    @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'created_user'
    })
    createdUser: string | null;

    @UpdateDateColumn({
        name: 'updated_at'
    })
    updatedAt: Date;

    @Column('varchar', {
        nullable: true,
        length: 40,
        name: 'updated_user'
    })
    updatedUser: string | null;

    @OneToMany(type => StoreConsumptionItems, storeConItems => storeConItems.storeConsumptionInfo, {cascade: true})
    storeConsumptionItems: StoreConsumptionItems[];

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @Column('int', {
        nullable: true,
        name: 'tracebility_code_id',
    })
    tracebilityCodeId: number;

    @Column('boolean',{
        name:'mis_flag',
        default:0
    })
    misFlag : boolean

    @Column('int', {
        nullable: true,
        name: 'issued_to',
    })
    issuedTo: number;

    @Column('int' ,{
        nullable:false,
        name:'department_id',
    })
    departmentId:number
}